import { styled, Box } from '@mui/material'

const CardIcon = styled(Box)`
  background: ${props => props.color};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 13px;
  width: 68px;
  height: 68px;
  margin-top: -26px;
  position: absolute;
  box-shadow: -1px -1px 3px rgba(0, 0, 0, 0.1), 3px 3px 3px rgba(0, 0, 0, 0.1);
  margin-left: -20px !important;

  @media screen and (max-width: 600px) {
    width: 56px;
    margin-left: -13px !important;
    margin-top: -18px;
    height: 56px;
  }

  @media screen and ((min-width: 601px) and ( max-width: 1400px)) {
    width: 56px;
    height: 56px;
    margin-left: -24px !important;
  }
`
export default CardIcon
